import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import greyCarrot from '../../Images/greyCarrot.png';
import './VideoCarousel.css';
import VideoPlayer from "../../Components/VideoPlayer/VideoPlayer.js";

const VideoCarousel = ({ arrayOfVideoUrls }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const carouselRef = useRef(null);

  useEffect(() => {
    if (carouselRef.current) {
      carouselRef.current.scrollLeft = currentIndex * carouselRef.current.offsetWidth;
    }
  }, [currentIndex]);

  const handlePrev = () => {
    setCurrentIndex(prev => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentIndex(prev => Math.min(prev + 1, arrayOfVideoUrls.length - 1));
  };

  return (
    <div className="video-carousel-container">
      <div className="video-carousel" ref={carouselRef}>
        {arrayOfVideoUrls.map((video, index) => (
          <div className="carousel-slide" key={index}>
            <VideoPlayer
              videoSrc={typeof video === 'string' ? video : video.url}
              controls
              className="carousel-video"
              
            />
          </div>
        ))}
      </div>
      <div className="carousel-buttons">
        <button 
          className="carousel-button prev-button" 
          onClick={handlePrev} 
          disabled={currentIndex === 0}
        >
          <img src={greyCarrot} alt="Previous" className="arrow-left" />
        </button>
        <button 
          className="carousel-button next-button" 
          onClick={handleNext} 
          disabled={currentIndex === arrayOfVideoUrls.length - 1}
        >
          <img src={greyCarrot} alt="Next" className="arrow-right" />
        </button>
      </div>
    </div>
  );
};

VideoCarousel.propTypes = {
  arrayOfVideoUrls: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        fileName: PropTypes.string,
        url: PropTypes.string,
      }),
    ])
  ).isRequired,
};

export default VideoCarousel;
